import { render, staticRenderFns } from "./taux-observations.html?vue&type=template&id=4d0d43ec&scoped=true&external"
import script from "./taux-observations.js?vue&type=script&lang=js&external"
export * from "./taux-observations.js?vue&type=script&lang=js&external"
import style0 from "./taux-observations.scss?vue&type=style&index=0&id=4d0d43ec&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0d43ec",
  null
  
)

export default component.exports